/* Houndfield "Site Plan" interactions. No dependencies. Every effect is optional:
   the page is complete without JS, and motion is skipped under prefers-reduced-motion. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('hf-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $all(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function heroPlan() { return d.querySelector('.hf-plan--hero'); }
  function hl(z) { var p = heroPlan(); if (!p) return; if (z) p.setAttribute('data-hl', z); else p.removeAttribute('data-hl'); }

  function initHeader(scope) {
    /* ---- mega menu: hover intent + click + keyboard ---- */
    var items = $all('.hf-nav__i[data-mega]', scope), closeT, openT;
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) { it.classList.remove('is-open'); var b = it.querySelector('.hf-nav__a'); if (b) b.setAttribute('aria-expanded', 'false'); } });
    }
    function open(it) { closeAll(it); it.classList.add('is-open'); var b = it.querySelector('.hf-nav__a'); if (b) b.setAttribute('aria-expanded', 'true'); }
    items.forEach(function (it) {
      var btn = it.querySelector('.hf-nav__a'), z = it.getAttribute('data-z');
      it.addEventListener('mouseenter', function () { clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(function () { open(it); }, items.some(function (x) { return x.classList.contains('is-open'); }) ? 0 : 90); if (z) hl(z); });
      it.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(function () { it.classList.remove('is-open'); if (btn) btn.setAttribute('aria-expanded', 'false'); }, 160); hl(null); });
      if (btn && btn.tagName === 'BUTTON') btn.addEventListener('click', function () { it.classList.contains('is-open') ? closeAll() : open(it); });
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); if (btn) btn.setAttribute('aria-expanded', 'false'); } });
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var o = d.querySelector('.hf-nav__i.is-open .hf-nav__a'); closeAll(); closeDrawer(); if (o) o.focus(); } });

    /* ---- mobile drawer ---- */
    var mb = d.querySelector('.hf-menu-btn'), dr = d.getElementById('hf-drawer'), hdr = d.querySelector('.hf-hdr');
    function closeDrawer() { if (!dr || !mb) return; dr.classList.remove('is-open'); mb.setAttribute('aria-expanded', 'false'); root.style.overflow = ''; }
    if (mb && dr) {
      mb.addEventListener('click', function (e) {
        var isOpen = dr.classList.toggle('is-open');
        mb.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (hdr) dr.style.setProperty('--hf-drawer-top', Math.max(0, hdr.getBoundingClientRect().bottom) + 'px');
        root.style.overflow = isOpen ? 'hidden' : '';
        if (isOpen && e.detail === 0) { var f = dr.querySelector('a'); if (f) f.focus({ preventScroll: true }); }
      });
    }
  }
  function initSections(scope) {
    /* ---- hero zone key highlights the plan ---- */
    $all('[data-hl-zone]', scope).forEach(function (el) {
      var z = el.getAttribute('data-hl-zone');
      ['mouseenter', 'focus'].forEach(function (ev) { el.addEventListener(ev, function () { hl(z); }); });
      ['mouseleave', 'blur'].forEach(function (ev) { el.addEventListener(ev, function () { hl(null); }); });
    });

    /* ---- sizer ---- */
    $all('.hf-sizer[data-sizes]', scope).forEach(function (sec) {
      var data; try { data = JSON.parse(sec.getAttribute('data-sizes')); } catch (e) { return; }
      var btns = $all('.hf-seg button', sec);
      function set(key) {
        var s = data[key]; if (!s) return;
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-s') === key ? 'true' : 'false'); });
        $all('.hf-sz,.hf-sz-tags', sec).forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-s') === key); });
        $all('[data-fit]', sec).forEach(function (li, i) { var r = s.fits[i]; if (!r) return; li.querySelector('[data-fit-t]').textContent = r[0]; li.querySelector('[data-fit-q]').textContent = r[1]; });
        $all('[data-sz-field]', sec).forEach(function (el) { var k = el.getAttribute('data-sz-field'); if (s[k] != null) el.textContent = s[k]; });
        var cta = sec.querySelector('[data-sz-cta]');
        if (cta) { var base = cta.getAttribute('data-base') || cta.getAttribute('href').split('?')[0]; cta.setAttribute('data-base', base); cta.setAttribute('href', base + '?size=' + encodeURIComponent(s.area)); var t = cta.querySelector('[data-sz-cta-t]'); if (t) t.textContent = 'Start a plan at ' + s.area + ' sq ft'; }
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-s')); }); });
      var on = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      set(on ? on.getAttribute('data-s') : 'm');
    });

    /* ---- scroll reveals ----
       Nothing is hidden in advance. Elements below the fold get .is-rising (a short entrance
       animation) as they come within 12% of the viewport; anything never reached stays visible. */
    var rv = $all('.hf-rv, .hf-psheet', scope);
    if ((window.Shopify && window.Shopify.designMode) || reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight || root.clientHeight || 800;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var r = e.boundingClientRect;
        /* already on screen (fast jump, restored scroll): leave it alone instead of flashing it out */
        if (r.top < (e.rootBounds ? e.rootBounds.height : vh) * 0.85) { e.target.classList.add('is-in'); }
        else { e.target.classList.add('is-rising', 'is-in'); }
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });
    rv.forEach(function (el) { if (el.getBoundingClientRect().top >= vh) io.observe(el); });
  }
  function init() {
    initHeader(d);
    initSections(d);
    /* ---- park plan form: prefill size from ?size= ---- */
    var m = /[?&]size=([^&]+)/.exec(location.search), sz = d.querySelector('[data-hf-size-input]');
    if (m && sz && !sz.value) sz.value = decodeURIComponent(m[1]).replace(/\+/g, ' ') + ' sq ft';
    var pm = /[?&]product=([^&]+)/.exec(location.search), pi = d.querySelector('[data-hf-product-input]');
    if (pm && pi && !pi.value) pi.value = decodeURIComponent(pm[1]).replace(/[-+]/g, ' ');
  }
  /* theme editor: re-bind a section after it re-renders */
  d.addEventListener('shopify:section:load', function (e) { var t = e.target; if (!t) return; if (t.querySelector('.hf-hdr')) initHeader(t); initSections(t); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
